import React, { useEffect, useState } from 'react'
import { maxWidthMapping } from '@/config/ts/tailwind'
import Curve from '@/svg/curves'

type ContainerType = {
    /** xs: 600px | sm: 900px | md: 1140px | lg: 1280px */
    maxWidth: 'xs' | 'sm' | 'md' | 'lg'
    /** Default: lg xs=20px:40px sm=32px:96px:128px | md=:48px:112px:160px | lg=64px:128px:200px */
    paddingYPreset: 'article' | 'xs' | 'sm' | 'md' | 'lg'
    /** Default: p defines whether y is padding or margin */
    pmY?: 'p' | 'm'
    /** Determines what theme is selected */
    theme?: string
    /** Show curved background */
    curved?: boolean
    /** Classname */
    classes?: string
    spacingClasses?: string
    id?: string
    children: React.ReactNode
}

const Container: React.FunctionComponent<ContainerType> = ({
    maxWidth = 'md',
    paddingYPreset = 'lg',
    pmY = 'p',
    theme,
    curved,
    classes,
    spacingClasses,
    id,
    children,
}) => {
    const paddingOrMargin = theme !== 'white' ? (pmY = 'p') : (pmY = 'm')

    const paddingYPresets = {
        article: `py-5 md:py-8 lg:py-10`,
        xs: `${pmY}y-[100px] lg:${pmY}y-10`,
        sm: `${pmY}y-[100px] md:${pmY}y-[120px] lg:${pmY}y-24`,
        md: `${pmY}y-[100px] md:${pmY}y-[7.5rem]`,
        lg: `${pmY}y-[100px] md:${pmY}y-[150px]`,
    }
    const [dynamicClass, setDynamicClass] = useState(paddingYPresets[paddingYPreset])
    const [dynamicMaxWidthClass, setDynamicMaxWidthClass] = useState(maxWidthMapping['md'])

    useEffect(() => {
        const paddingYClass = paddingYPreset
            ? paddingYPresets[paddingYPreset]
            : paddingYPresets['lg']
        setDynamicClass(`${paddingYClass} ${classes} ${curved ? 'bg-black text-white' : ''}`)
    }, [maxWidth, paddingYPreset, paddingOrMargin, paddingYPresets, classes, curved])

    useEffect(() => {
        const maxWidthClass = maxWidth ? maxWidthMapping[maxWidth] : maxWidthMapping['md']
        setDynamicMaxWidthClass(maxWidthClass)
    }, [maxWidth])
    return (
        <section
            id={id}
            className={`${classes} last-of-type:pb-3 lg:last-of-type:pb-10 2xl:last-of-type:pb-16`}
        >
            {curved && Curve('rotate-180 -mb-px fill-current')}
            <div className={`w-full px-5 sm:px-10 ${dynamicClass} ${spacingClasses}`}>
                <div className={`${dynamicMaxWidthClass} m-auto`}>{children}</div>
            </div>
            {curved && Curve('fill-current -mt-px')}
        </section>
    )
}

export default Container
